export default __webpack_public_path__ + "static/media/42t.38497923.jpg";